<script setup lang="ts">
import HeartIcon from '@/shared/ui/Icons/Heart.vue';
import { useUserStore } from '@/entities/user/index';
import { useModalsStore } from '@/app/store/modals';
import type { IFavoriteButton } from '@/features/FavoriteButton/model/types/favorite';

const props = withDefaults(defineProps<IFavoriteButton>(), {
  modelValue: false,
  text: '',
});

const { t } = useI18n();
const userStore = useUserStore();
const modalsStore = useModalsStore();
const { $productsService } = useNuxtApp();

const emit = defineEmits(['update:modelValue']);

const isAuth = computed(() => userStore.isAuth);

const toggleFavorite = async (): Promise<void> => {
  try {
    if (!isAuth.value) {
      modalsStore.setModalState('auth', true);
      return;
    }

    await $productsService.toggleFavorite(props.entityId);
    emit('update:modelValue', !props.modelValue);
  } catch (error) {
    console.error('Ошибка при добавлении в избранное:', error);
  }
};
</script>

<template>
  <button
    :class="['favorite-button', { _active: modelValue }]"
    @click.prevent="toggleFavorite"
  >
    <div class="favorite-button__icon-wrapper" :aria-label="t('addToFavorite')">
      <HeartIcon class="favorite-button__icon" />
    </div>
    <span v-if="text" class="favorite-button__text">{{ text }}</span>
  </button>
</template>

<style lang="less">
.favorite-button {
  .button-reset();

  display: flex;
  justify-content: center;
  align-items: center;
  gap: @size-x3;

  &__icon-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: @size-x8;
    height: @size-x8;
    background-color: #fff;
    border-radius: 50%;
  }

  &__icon {
    width: 18px;
    height: 18px;
  }

  &:hover &__icon path {
    stroke: @color-carnation;
    fill: @color-carnation;
  }

  &._active &__icon path {
    stroke: @color-carnation;
    fill: @color-carnation;
  }

  &__text {
    font-size: 15px;
    font-weight: 500;
    line-height: 100%;
  }

  @media @1024 {
    &__icon-wrapper {
      width: @size-x6;
      height: @size-x6;
    }

    &__icon {
      width: 14px;
      height: 14px;
    }
  }
}
</style>
